/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".dialog-label[_ngcontent-%COMP%]{font-weight:700;margin-bottom:10px}[_nghost-%COMP%]     .p-dialog{width:90%!important;max-width:500px}[_nghost-%COMP%]     .p-dialog-footer{justify-content:flex-end!important}.table-header[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{margin-right:0}.add-btn[_ngcontent-%COMP%]{justify-content:flex-end!important;width:100%;margin-bottom:20px!important}.add-btn[_ngcontent-%COMP%], .table-header[_ngcontent-%COMP%]{display:flex;align-items:center}.table-header[_ngcontent-%COMP%]{justify-content:flex-end;padding:.5rem}"];
export { styles as styles };

